import React from 'react';
import { ICONS } from 'Components/utils/icon/icons';
import { COLORS } from 'Components/utils/color/colors';
import { Button } from 'Components/frameworks/button/Button';
type AdditionalTransportFilterButtonProps = {
  label: string;
  isSelected: boolean;
  onClick: () => void;
};
export const AdditionalTransportFilterButton = ({
  label,
  isSelected,
  onClick,
}: AdditionalTransportFilterButtonProps) => (
  <div data-testid="AdditionalTransportFilterButton">
    <Button
      className="text-16 font-semibold"
      data-selector="AdditionalTransportFilterButton-button"
      iconRight={
        isSelected
          ? {
              name: ICONS.CHECK,
            }
          : undefined
      }
      onClick={onClick}
      color={COLORS.BLACK}
      colorBg={isSelected ? COLORS.SAFFRON : COLORS.WHITE}
      colorBorder={isSelected ? COLORS.SAFFRON : COLORS.BLACK}
      size="medium"
    >
      {label}
    </Button>
  </div>
);
